// extracted by mini-css-extract-plugin
export default {"privacy":"Privacy_privacy__LG6nh"};